import Axios from 'api/client';
import qs from 'qs';
import { PromoCode } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface FetchPromoCodesParams extends FilterParams {}

const fetchPromoCodes = (accountId: number, params: FetchPromoCodesParams = {}) => {
    const { filters, ...restParams } = params;
    const stringifiedFilters = filters ? qs.stringify(filters) : '';

    return Axios.get<PaginatedData<PromoCode>>(
        `/accounts/${accountId}/discount_codes?${stringifiedFilters}`,
        {
            params: restParams,
        },
    ).then(response => response.data);
};

export { fetchPromoCodes };
export type { FetchPromoCodesParams };
